import { useTranslation } from "react-i18next";
import { Flex, Box, Image, Button } from "@chakra-ui/react";
import getImageSrc from "src/utils/getImageSrc";
import { H3, BodyText2 } from "src/atoms/typography";
import Modal from "src/components/Modal";

export default function MotionErrorDialog({
  isOpen,
  onClose,
  isParentStation,
  motionDetectorState
}) {
  const { t } = useTranslation();

  const errorStrings = {
    STOPPED_REASON_LOW_CAMERA_EXPOSURE: "motionDetection.error.lowVisibility",
    STOPPED_REASON_LYING_DEVICE: "motionDetection.error.deviceLying",
    STOPPED_REASON_FLASHLIGHT_ACTIVE: "motionDetection.error.flashlight"
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Box width="280px">
        <Flex
          mt="24px"
          mx="24px"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <Image
            width="137px"
            height="115px"
            mb="16px"
            src={getImageSrc("motion-error.svg")}
          />

          <H3 textAlign="center" mb="8px" color="highEmphasis">
            {t(
              isParentStation
                ? "motionDetection.error.heading"
                : "motionDetection.explainer.unableToDetect.heading"
            )}
          </H3>
          <BodyText2 textAlign="center" mb="24px" color="mediumEmphasis">
            {t(errorStrings[motionDetectorState])}
          </BodyText2>
        </Flex>
        <Flex mt="16px" mb="8px" justifyContent="center">
          <Button
            variant="flatPrimary"
            onClick={() => onClose()}
            minWidth="80px"
          >
            {t("buttons.ok")}
          </Button>
        </Flex>
      </Box>
    </Modal>
  );
}
